import _get from "lodash.get";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

import { INVITE_REQUEST_FIELDS } from "hooks/useContractQueries";

const GET_PARENT_LATEST_CONTRACT = gql`
  ${INVITE_REQUEST_FIELDS}
  query GetParentLatestContract($id: Int!) {
    contracts: allContracts(
      page: 1
      perPage: 1
      sortField: "createdAt"
      sortOrder: "DESC"
      filter: { organizationId: $id }
    ) {
      id
      autoUsersInactive
      communityAccess
      inviteEmailIntro
      inviteEmailOutro
      ...InviteRequestFields
      seats
      talkUploads
      usersActiveForDays
    }
  }
`;

const useParentContractDefaults = (parentId) => {
  const { data, loading, error } = useQuery(GET_PARENT_LATEST_CONTRACT, {
    skip: !parentId,
    variables: {
      id: parseInt(parentId, 10)
    },
    fetchPolicy: "network-only"
  });

  const contract = _get(data, "contracts[0]");

  return {
    data: contract || null,
    loading,
    error
  };
};

export default useParentContractDefaults;
